import React from "react";
import { TICKER_WORDS } from "@/lib/pulseConstants";

export default function Marquee({ words = TICKER_WORDS, direction = "left", speed = "normal" }) {
    const animationClass = direction === "right"
        ? "animate-marquee-reverse"
        : speed === "fast"
            ? "animate-marquee-fast"
            : "animate-marquee";
    const items = [...words, ...words];
    return (
        <div className="relative overflow-hidden py-6 border-y border-white/10 bg-black" data-testid="home-marquee">
            <div className={`ticker-track ${animationClass}`}>
                {items.map((word, idx) => (
                    <div className="ticker-item" key={`${word}-${idx}`}>
                        <span>{word}</span>
                        <span className="ticker-dot" aria-hidden="true" />
                    </div>
                ))}
            </div>
        </div>
    );
}
